import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import 'assets/css/viewer.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueViewer, {
    defaultOptions: {
      movable: false,
      title: false,
      toolbar: {
        flipHorizontal: false,
        flipVertical: false,
         prev: true,
        next: true,
        oneToOne: false,
        play: false,       
        reset: false,
        rotateLeft: false,
        rotateRight: false,
        zoomIn: false,
        zoomOut: false,
      },
      transition: false,
    },
  })
})
